exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-main[data-v-6071ca58]{border-top:1px solid #dedede;height:100%}.div-top[data-v-6071ca58]{display:flex;padding:.375rem .625rem;align-items:center;height:2.875rem}.div-top .org-name[data-v-6071ca58]{flex:2;font-size:14px;font-weight:bolder;color:#464646;margin-left:.375rem}.div-top .filter[data-v-6071ca58]{text-align:right;flex:1}.div-top .filter span[data-v-6071ca58]{font-size:.875rem}.div-top .filter img[data-v-6071ca58]{width:1.25rem;vertical-align:middle}.cont-list[data-v-6071ca58]{overflow:auto;height:100%}[data-v-6071ca58] .van-tabs__line{background-color:#c52a1a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6071ca58","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/history/HisOrgList.vue
// module id = 864
// module chunks = 0